import { useState } from 'react';
import { HelpCenter } from '@dataroom/shared';
import { ContactSupportModal } from '@/components/ContactSupportModal';

/** The admin Help center (/help): the admin articles, plus the Contact support form. */
export function HelpPage() {
  const [supportOpen, setSupportOpen] = useState(false);
  return (
    <>
      <HelpCenter audience="admin" onContactSupport={() => setSupportOpen(true)} />
      {supportOpen ? <ContactSupportModal onClose={() => setSupportOpen(false)} /> : null}
    </>
  );
}
